/**
 * Admin auth context definition - separated to comply with react-refresh rules.
 */

import { createContext } from 'react'
import type { UseAdminAuthReturn } from './useAdminAuth.js'

export const AdminAuthContext = createContext<UseAdminAuthReturn | null>(null)
